import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

const TOKEN_KEY = "gestaocv_token";

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
}

// Restore token on load
const saved = typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
if (saved) api.defaults.headers.common.Authorization = `Bearer ${saved}`;

export function apiError(err, fallback = "Ocorreu um erro. Tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (detail === "subscription_required")
    return "A sua subscrição não está ativa. Escolha um plano para continuar.";
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;
